import React, { useEffect, useState } from 'react';
import NhacPhatGiaoPageApi from "./NhacPhatGiaoPageApi";
import TintucPageApi from "./TintucPageApi";
import { API_URL, FILE_URL } from './Constants';
import FtpFileBrowser from './FtpFileBrowser';

const Toggle = ({ value, onClick }) => (
  <div onClick={onClick} style={{ cursor: 'pointer', display: 'inline-block', width: '62px', height: '26px', position: 'relative', overflow: 'hidden', borderRadius: '3px' }}>
    <div style={{ width: '92px', position: 'relative', left: value ? '0' : '-31px', transition: 'left 0.2s', display: 'flex' }}>
      <span style={{ width: '31px', textAlign: 'center', background: '#4d90fe', color: '#fff', lineHeight: '26px', fontSize: '11px', fontWeight: 'bold' }}>ON</span>
      <span style={{ width: '30px', background: '#fff', border: '1px solid #ccc', lineHeight: '26px' }}>&nbsp;</span>
      <span style={{ width: '31px', textAlign: 'center', background: '#bbb', color: '#555', lineHeight: '26px', fontSize: '11px', fontWeight: 'bold' }}>OFF</span>
    </div>
  </div>
);

const AdminNhacPhatGiaoEditPage = ({ currentPostId, clickChangeMenu, postType = 8 }) => {
  const [danhmuc, setDanhmuc] = useState([]);
  const [parentList, setParentList] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [saveMessage, setSaveMessage] = useState('');
  const [previewImage, setPreviewImage] = useState(null);
  const [previewMp3, setPreviewMp3] = useState(null);
  const [showFtpBrowser, setShowFtpBrowser] = useState(false);
  const [showFtpMp3Browser, setShowFtpMp3Browser] = useState(false);

  const initialFormData = {
    postId: "", title: "", description: "", seoUrl: "", 
    categories: [], image: null, active: false, isNew: false,
    isHot: false, isHome: false, isSlide: false,
    sort: "", linkMp3: "", imageMp3: "", parentId: "0",
    tacGia: "", nxb: "", dich: "", dienDoc: "",
    isDeleteFile: false, isDeleteImage: false, ftpImagePath: "", postType: postType
  };

  const [formData, setFormData] = useState(initialFormData);

  const handleCheckboxChange = (id) => {
    setSelectedCategories((prev) => {
      const updated = prev.includes(id) ? prev.filter((cid) => cid !== id) : [...prev, id];
      setFormData((f) => ({ ...f, categories: updated }));
      return updated;
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const updated = { ...formData, [name]: value };
    if (name === "title") {
      updated.seoUrl = value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/ /g, "-");
    }
    setFormData(updated);
  };

  const handleFtpImageSelect = (file) => {
    setPreviewImage(FILE_URL + file.path);
    setFormData((f) => ({ ...f, image: null, ftpImagePath: file.path, isDeleteFile: true }));
    setShowFtpBrowser(false);
  };

  const handleFtpMp3Select = (file) => {
    setFormData((f) => ({ ...f, linkMp3: file.path }));
    setShowFtpMp3Browser(false);
  };

  const handleDeleteImage = () => {
    setPreviewImage(null);
    setFormData(f => ({ ...f, image: null, ftpImagePath: "", isDeleteFile: true }));
  };

  const handleSubmit = async (mode = 'save') => {
    setIsLoading(true); setSaveMessage('');
    try {
      const response = currentPostId != null 
        ? await NhacPhatGiaoPageApi.updatePost(formData) 
        : await NhacPhatGiaoPageApi.submitPost(formData);
      
      if (response && response.status === 'ERROR') {
        setSaveMessage('Lưu thất bại: ' + (response.message || 'Lỗi hệ thống'));
      } else {
        setSaveMessage('Lưu thành công!');
        if (mode === 'save') setTimeout(() => clickChangeMenu && clickChangeMenu('nhacphatgiao'), 1500);
        else if (mode === 'save-create') setTimeout(() => { setFormData(initialFormData); setSelectedCategories([]); setIsActive(false); setIsNew(false); setPreviewImage(null); setSaveMessage(''); }, 1500);
        else setTimeout(() => setSaveMessage(''), 3000);
      }
    } catch { setSaveMessage('Lưu thất bại!'); }
    setIsLoading(false);
  };

  useEffect(() => {
    TintucPageApi.getAllType(postType).then(setDanhmuc).catch(console.error);
    NhacPhatGiaoPageApi.getParentListAdmin().then(setParentList).catch(console.error);
  }, [postType]);

  useEffect(() => {
    if (currentPostId != null) {
      NhacPhatGiaoPageApi.getChiTietNhacPhatGiaoAdmin(currentPostId, postType).then((data) => {
        if (data && data.length > 0) {
          const p = data[0];
          const cats = p.categoriesId ? p.categoriesId.split(';').map(id => parseInt(id)) : [];
          const updated = {
            postId: currentPostId, title: p.title, description: p.description || "",
            seoUrl: p.slug_full, categories: cats, image: p.thumb,
            active: p.active, 
            isNew: p.is_new || false,
            isHot: p.is_hot || false,
            isHome: p.is_home || false,
            isSlide: p.is_slide || false,
            sort: p.sort || "", linkMp3: p.fileFdf || p.link_mp3 || p.linkMp3 || "",
            imageMp3: p.image_mp3 || "", parentId: p.parent_id || "0",
            tacGia: p.tacgia || "", nxb: p.nxb || "", dich: p.dich || "",
            isDeleteFile: false, isDeleteImage: false, ftpImagePath: "", postType: postType
          };
          setFormData(updated); setSelectedCategories(cats);
          setIsActive(updated.active); setIsNew(updated.isNew);
          if (p.thumb) {
            setPreviewImage(FILE_URL + p.thumb);
            if (p.thumb.startsWith('/linhquyphapan/files/')) setFormData(prev => ({ ...prev, ftpImagePath: p.thumb }));
          }
        }
      }).catch(console.error);
    }
  }, [currentPostId]);

  const actionButtons = (isBottom = false) => (
    <div className="btn-group">
      <button type="button" className="btn btn-success" onClick={() => handleSubmit('save')} disabled={isLoading}>
        {isBottom ? (currentPostId ? 'Sửa' : 'Tạo') : <><i className="icon-ok" /> {isLoading ? 'Đang lưu...' : 'Lưu'}</>}
      </button>
      <button type="button" className="btn" onClick={() => handleSubmit('save-edit')} disabled={isLoading}>Lưu và tiếp tục chỉnh sửa</button>
      <button type="button" className="btn" onClick={() => handleSubmit('save-create')} disabled={isLoading}>Lưu và tạo thêm Nhạc Phật Giáo</button>
      <button type="button" className="btn" onClick={() => clickChangeMenu && clickChangeMenu('nhacphatgiao')}>Quay lại</button>
    </div>
  );

  return (
    <div>
      <div className="social-box" style={{ position: 'sticky', top: '40px', zIndex: 1000, boxShadow: '0px 2px 4px rgba(0,0,0,0.1)' }}>
        <div className="header">
          {actionButtons(false)}
          {saveMessage && <span style={{ marginLeft: '20px', color: saveMessage.includes('thành') ? 'green' : 'red', fontWeight: 'bold' }}>{saveMessage}</span>}
        </div>
      </div>

      <div className="social-box">
        <div className="form-horizontal" style={{ padding: '20px' }}>
          <h4 style={{ color: '#999', fontWeight: 'normal', margin: '0 0 10px', fontSize: '13px' }}>Thông tin chung</h4>
          <hr style={{ margin: '0 0 15px', borderColor: '#e5e5e5' }} />

          <div className="control-group">
            <label className="control-label">Tiêu đề:</label>
            <div className="controls"><input type="text" name="title" className="span12" value={formData.title} onChange={handleInputChange} /></div>
          </div>
          <div className="control-group">
            <label className="control-label">Tóm tắt:</label>
            <div className="controls"><textarea name="description" className="span12" rows="4" value={formData.description} onChange={handleInputChange} /></div>
          </div>
          <div className="control-group">
            <label className="control-label" style={{ whiteSpace: 'pre-line' }}>{'Đường dẫn thân thiện\n(SEO)'}:</label>
            <div className="controls"><input type="text" name="seoUrl" className="span12" value={formData.seoUrl} onChange={handleInputChange} readOnly style={{ background: '#f5f5f5' }} /></div>
          </div>
        </div>
      </div>

      <div className="social-box">
        <div className="form-horizontal" style={{ padding: '0 20px 20px' }}>
          <h4 style={{ color: '#999', fontWeight: 'normal', margin: '15px 0 10px', fontSize: '13px' }}>Thông tin</h4>
          <hr style={{ margin: '0 0 15px', borderColor: '#e5e5e5' }} />

          <div className="control-group">
            <label className="control-label">Chuyên mục:</label>
            <div className="controls">
              <label className="checkbox" style={{ fontWeight: 'bold' }}>
                <input type="checkbox" checked={selectedCategories.length === danhmuc.length && danhmuc.length > 0} onChange={() => {
                  const newSel = selectedCategories.length === danhmuc.length ? [] : danhmuc.map(i => i.Id);
                  setSelectedCategories(newSel); setFormData(f => ({ ...f, categories: newSel }));
                }} /> [Chọn tất cả]
              </label>
              <div style={{ maxHeight: '180px', overflowY: 'auto', border: '1px solid #e5e5e5', padding: '8px', borderRadius: '3px', background: '#fcfcfc' }}>
                {danhmuc.map(cat => (
                  <label key={cat.Id} className="checkbox" style={{ margin: '2px 0' }}>
                    <input type="checkbox" checked={selectedCategories.includes(cat.Id)} onChange={() => handleCheckboxChange(cat.Id)} /> {cat.Name}
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="control-group">
            <label className="control-label">Hình ảnh:</label>
            <div className="controls">
              <div style={{ display: 'inline-flex', gap: '5px', alignItems: 'center' }}>
                <input type="text" readOnly className="span8" value={formData.ftpImagePath || (typeof formData.image === 'string' ? formData.image : '')} />
                <button type="button" className="btn" onClick={() => setShowFtpBrowser(true)}>Duyệt ảnh</button>
              </div>
              {previewImage && <div style={{ marginTop: '5px' }}><img src={previewImage} alt="Preview" style={{ maxWidth: '150px', maxHeight: '100px', border: '1px solid #ddd' }} /><button type="button" className="btn btn-danger btn-mini" style={{ marginLeft: '8px' }} onClick={handleDeleteImage}>Xóa</button></div>}
            </div>
          </div>

          <div className="control-group">
            <label className="control-label">Thứ tự:</label>
            <div className="controls"><input type="text" name="sort" className="span3" value={formData.sort} onChange={handleInputChange} /></div>
          </div>

          <div className="control-group">
            <label className="control-label">Kích hoạt:</label>
            <div className="controls" style={{ paddingTop: '4px' }}><Toggle value={isActive} onClick={() => { const v = !isActive; setIsActive(v); setFormData(f => ({ ...f, active: v })); }} /></div>
          </div>

          <div className="control-group">
            <label className="control-label">New:</label>
            <div className="controls" style={{ paddingTop: '4px' }}><Toggle value={isNew} onClick={() => { const v = !isNew; setIsNew(v); setFormData(f => ({ ...f, isNew: v })); }} /></div>
          </div>

          <div className="control-group">
            <label className="control-label">Nhạc Phật Giáo cha:</label>
            <div className="controls">
              <select name="parentId" className="span6" value={formData.parentId} onChange={handleInputChange}>
                <option value="0">[Chọn Nhạc Phật Giáo cha]</option>
                {parentList.map(p => <option key={p.postId} value={p.postId}>{p.title}</option>)}
              </select>
            </div>
          </div>

          <h4 style={{ color: '#999', fontWeight: 'normal', margin: '20px 0 10px', fontSize: '13px' }}>Video Audio</h4>
          <hr style={{ margin: '0 0 15px', borderColor: '#e5e5e5' }} />

          <div className="control-group">
            <label className="control-label">Link MP3:</label>
            <div className="controls">
              <div style={{ display: 'inline-flex', gap: '5px', alignItems: 'center' }}>
                <input type="text" name="linkMp3" className="span8" value={formData.linkMp3} onChange={handleInputChange} />
                <button type="button" className="btn" onClick={() => setShowFtpMp3Browser(true)}>Duyệt file</button>
              </div>
            </div>
          </div>

          <div className="control-group">
            <label className="control-label">Hình nền Audio:</label>
            <div className="controls"><input type="text" name="imageMp3" className="span12" value={formData.imageMp3} onChange={handleInputChange} /></div>
          </div>

          <div className="control-group">
            <label className="control-label">Tác giả:</label>
            <div className="controls"><input type="text" name="tacGia" className="span6" value={formData.tacGia} onChange={handleInputChange} /></div>
          </div>

          <div className="control-group">
            <label className="control-label">NXB:</label>
            <div className="controls"><input type="text" name="nxb" className="span6" value={formData.nxb} onChange={handleInputChange} /></div>
          </div>

          <div className="control-group">
            <label className="control-label">Dịch:</label>
            <div className="controls"><input type="text" name="dich" className="span6" value={formData.dich} onChange={handleInputChange} /></div>
          </div>
        </div>
      </div>

      <div className="social-box">
        <div className="header">{actionButtons(true)}</div>
      </div>

      {showFtpBrowser && <FtpFileBrowser isOpen onClose={() => setShowFtpBrowser(false)} onSelectFile={handleFtpImageSelect} fileFilter={['.jpg','.jpeg','.png','.gif','.webp']} title="Chọn hình ảnh" />}
      {showFtpMp3Browser && <FtpFileBrowser isOpen onClose={() => setShowFtpMp3Browser(false)} onSelectFile={handleFtpMp3Select} fileFilter={['.mp3','.m4a','.ogg']} title="Chọn file MP3" />}
    </div>
  );
};

export default AdminNhacPhatGiaoEditPage;
